// @flow

import * as React from 'react';
import padStart from 'lodash/padStart';
import { t } from '../lib/i18n';
import moment from 'moment';
import styled from 'styled-components';


type Props = {
    date: Date,
    className: string,
    timeIntervalNames: string[],
    lastFullSecondTimestamp: number,
};


class Countdown extends React.Component<Props> {
    static defaultProps = {
        timeIntervalNames: [
            'hours',
            'minutes',
            'seconds'
        ],
    };

    formatDigits(digits: number) {
        return padStart(String(digits), 2, '0');
    }

    wrapInDigitElements(digits: string) {
        return digits.split('').map((digit, i) => <span key={i} className="digit">{digit}</span>);
    }

    renderPart(duration: moment.Duration, timeIntervalName: string) {
        const timeDigits = Math.floor(duration[timeIntervalName]());

        return (<div key={timeIntervalName} className={`number ${timeIntervalName}`}>
            <header>
                {this.wrapInDigitElements(this.formatDigits(timeDigits))}
            </header>
            <footer>{t(`time.${timeIntervalName}`)}</footer>
        </div>);
    }

    render() {
        const startDate = this.props.date;
        if (!startDate || !this.props.lastFullSecondTimestamp) return null;
        const now = new Date(this.props.lastFullSecondTimestamp);
        const diff = startDate - now;
        const duration = moment.duration(diff)

        return (<section className={`countdown ${this.props.className}`}>
            {this.props.timeIntervalNames.map((timeIntervalName) => this.renderPart(duration, timeIntervalName))}
        </section>);
    }
}


export default styled(Countdown)`
    display: flex;
    flex-direction: row;

    > .number {
        display: flex;
        flex: 1;
        flex-direction: column;
        align-items: center;
        font-size: 1.25em;

        & + .number {
            margin-left: 0.25em;
        }

        > header {
            font-weight: 300;
        }
        > footer {
            font-weight: normal;
            text-transform: uppercase;
            font-size: 0.4em;
            opacity: 0.75;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/Reengagement/Countdown.jsx